import { MatchLevel } from 'dashboard/models/document';

export const matchLevelSatisfies = (
  matchLevel?: MatchLevel | null,
  otherMatchLevel?: MatchLevel | null,
) => {
  if (matchLevel == null || otherMatchLevel == null) return false;
  if (matchLevel === otherMatchLevel) return true;
  if (matchLevel === MatchLevel.Full) return true;
  if (matchLevel === MatchLevel.Partial) {
    if (otherMatchLevel === MatchLevel.Full) return false;
    return true;
  }
  return false;
};
